export default __webpack_public_path__ + "static/media/mo.ea97da00.svg";